/* Upsell a regole (2026-09-29) — aggiunta al carrello dalle proposte di
   snippets/wd-upsell-item.liquid (drawer, pagina /cart, scheda prodotto).

   Un solo listener delegato sul documento: drawer e /cart vengono ridisegnati
   dal server a ogni cambio, quindi i nodi non sopravvivono e gli script dentro
   l'HTML ridisegnato non girano.
   Niente <product-form> di Dawn: su /cart aprirebbe il drawer lasciando i
   totali della pagina vecchi, in scheda prodotto si scontrerebbe con il blocco
   «Scegli la taglia» (wd-boost.js) e con la barra sticky.
   Un 422 (esaurito, limite di giacenza) mostra il motivo e non ridisegna nulla:
   il vecchio «+» lo faceva sembrare riuscito. */
(function () {
  if (window.wdUpsellReady) return;
  window.wdUpsellReady = true;

  function item(el) {
    return el.closest('[data-wd-ups]');
  }

  function showError(it, msg) {
    var er = it.querySelector('.wd-ups__err');
    if (!er) return;
    er.textContent = msg;
    er.hidden = false;
  }

  function clearError(it) {
    var er = it.querySelector('.wd-ups__err');
    if (!er) return;
    er.textContent = '';
    er.hidden = true;
  }

  function inner(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector(selector);
    return node ? node.innerHTML : null;
  }

  // In cattura sul documento: il `change` non deve arrivare a <cart-items>
  // (cart.js lo tratta come un cambio di quantita' e cerca #Quantity-undefined).
  document.addEventListener(
    'change',
    function (e) {
      var s = e.target && e.target.closest ? e.target.closest('[data-wd-ups-select]') : null;
      if (!s) return;
      e.stopPropagation();
      var it = item(s);
      var opt = s.options[s.selectedIndex];
      var pr = it.querySelector('[data-wd-ups-price]');
      if (pr && opt && opt.dataset.price) pr.textContent = opt.dataset.price;
      clearError(it);
    },
    true
  );

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-wd-ups-add]') : null;
    if (!b || b.disabled) return;
    e.preventDefault();
    var it = item(b);
    var sel = it.querySelector('[data-wd-ups-select]');
    var vid = sel ? sel.value : b.dataset.vid;
    if (!vid) {
      showError(it, it.dataset.tChoose || '');
      if (sel) sel.focus();
      return;
    }
    clearError(it);

    var cartItems = document.querySelector('cart-items');
    var onCartPage = !!(cartItems && document.getElementById('main-cart-items') && cartItems.getSectionsToRender);
    var drawer = document.querySelector('cart-drawer');
    var pageSections = onCartPage ? cartItems.getSectionsToRender() : [];
    var ids = onCartPage ? pageSections.map(function (x) { return x.section; }) : ['cart-drawer', 'cart-icon-bubble'];
    if (onCartPage && drawer) ids.push('cart-drawer');

    var root = (window.routes && window.routes.cart_add_url) || ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add';
    var label = b.innerHTML;
    b.disabled = true;
    b.setAttribute('aria-busy', 'true');

    fetch(root + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(vid), quantity: 1 }],
        sections: ids.join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (json) {
        if (!json || json.status) {
          b.disabled = false;
          b.removeAttribute('aria-busy');
          b.innerHTML = label;
          showError(it, (json && (json.description || json.message)) || it.dataset.tErr || '');
          return;
        }
        var sections = json.sections || {};

        if (onCartPage) {
          pageSections.forEach(function (sec) {
            var host = document.getElementById(sec.id);
            if (!host || !sections[sec.section]) return;
            var target = host.querySelector(sec.selector) || host;
            var html = inner(sections[sec.section], sec.selector);
            if (html !== null) target.innerHTML = html;
          });
          cartItems.classList.remove('is-empty');
          var footer = document.getElementById('main-cart-footer');
          if (footer) footer.classList.remove('is-empty');
          // Il drawer si aggiorna senza aprirsi: si e' gia' sulla pagina carrello.
          var cd = document.getElementById('CartDrawer');
          if (drawer && cd && sections['cart-drawer']) {
            var dh = inner(sections['cart-drawer'], '#CartDrawer');
            if (dh !== null) {
              cd.innerHTML = dh;
              drawer.classList.remove('is-empty');
              var ov = document.getElementById('CartDrawer-Overlay');
              if (ov && drawer.close) ov.addEventListener('click', drawer.close.bind(drawer));
            }
          }
        } else if (drawer && drawer.renderContents && sections['cart-drawer']) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(json);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wd-upsell', cartData: json });
        }
      })
      .catch(function () {
        b.disabled = false;
        b.removeAttribute('aria-busy');
        b.innerHTML = label;
        showError(it, it.dataset.tErr || '');
      });
  });
})();
